import { Outlet, Navigate } from 'react-router-dom'
import {  useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../slices/commonReducer';
import { useEffect } from 'react';
import WebSocketService from '../services/websocketService';

const PrivateRoutes = (props) => {
    const token  = localStorage.getItem('token');
    const dispatch = useDispatch();
    const {permissions} = useSelector(state => state.common)

    let auth = {'token': token ? true : false}
    useEffect(() => {
        if (!permissions.length && token)
            dispatch(getUserDetails())

        if (token) {
            console.log("🔄 Restoring WebSocket connection after reload...");
            WebSocketService.connect(dispatch);
        }

    }, [permissions, token, dispatch])

    return(
        auth.token ? (permissions?.length ? <Outlet/>: '') : <Navigate to="/login"/>
    )
}

export default PrivateRoutes